import { ReportProfileRulesComputedDelegate } from '../../../profile/report-profile-rules-computed-delegate';

export class OneDriveReportProfileRulesComputedDelegate extends ReportProfileRulesComputedDelegate {
  hasInstantMessagingShare: boolean;
  instantMessagingFolders: string[];
}
